export type OkrDialogRequest = {
  params: Record<string, any>;
  callback?: () => void;
};

type Handler = (request: OkrDialogRequest) => void;

let handler: Handler | undefined;
// ponytail: unbounded queue, no timeout fallback if no host ever registers; iteration 2.
const queue: OkrDialogRequest[] = [];

/** The host adapter registers here; requests made before it mounts are replayed in order. */
export const registerOkrDialogHandler = (next: Handler) => {
  handler = next;
  queue.splice(0).forEach(next);
  return () => {
    if (handler === next) handler = undefined;
  };
};

// Called by the viewGoalDetailsPage funnel (wbgoal-table-widget.js) when the federated flag is on.
window.openFederatedOkrDialog = (params, callback) => {
  const request = { params, callback };
  if (handler) handler(request);
  else queue.push(request);
};
